import { metaAI } from "neql"
import { useNeqlContextProvider } from "./useNeqlContextProvider"

export const useAIModels = (
    condition:
        | { byName: true }
        | { rootId?: string | null; trainable?: boolean }
        | { trainable: true },
    appID: string
) => {
    const client = useNeqlContextProvider("metaAIApp", appID)

    return metaAI.useGetAiModelsQuery({
        client,
        variables: {
            offset: 0,
            limit: "byName" in condition ? 100 : 50,
            ...("trainable" in condition
                ? { where: { trainable: { _eq: true } } }
                : {}),
            ...("rootId" in condition && condition.rootId !== undefined
                ? {
                      where: {
                          root_id: { _eq: condition.rootId },
                          ...(condition.trainable !== undefined
                              ? {
                                    trainable: {
                                        _eq: condition.trainable
                                    }
                                }
                              : {})
                      },
                      orderBy: { version: metaAI.Order_By.Desc }
                  }
                : {})
        },
        skip:
            !("byName" in condition) &&
            "rootId" in condition &&
            (condition.rootId === undefined || condition.rootId === null)
    })
}
